// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../../components/Table";
// Engine
import { axiosAPI } from "../../../../engine/config/axios";

const Trackers:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;
  const gridParams = {
    grids: [{ name: 'trackers', hashCache }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  return <Table
    api={axiosAPI.settings.trackers.table}
    apiParams={apiParams}
    gridParams={gridParams}
    gridName="trackers"
    sortingMode="multiple"
  />;
}

function TrackersPortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<Trackers hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default TrackersPortal;
